import React from "react";

const PromotionSkeletons = ({ count = 6 }) => {
  return (
    <div className="rounded-xl border border-gray-800 bg-gray-900 p-4">
      <div className="grid grid-cols-1 gap-6 md:grid-cols-2 xl:grid-cols-3">
        {Array.from({ length: count }).map((_, index) => (
          <div
            key={index}
            className="animate-pulse rounded-xl border border-gray-800 bg-gray-900 p-4"
          >
            <div className="mb-4 h-32 w-full rounded-lg bg-gray-800" />

            <div className="space-y-3">
              {/* Title & badge row */}
              <div className="flex items-start justify-between gap-3">
                <div className="flex-1 space-y-2">
                  <div className="h-4 w-3/4 rounded bg-gray-800" />
                  <div className="h-3 w-1/2 rounded bg-gray-800" />
                </div>
                <div className="h-5 w-16 rounded-full bg-gray-800" />
              </div>

              {/* Description */}
              <div className="h-3 w-full rounded bg-gray-800" />

              {/* Code & Discount row */}
              <div className="mt-2 flex items-center justify-between gap-4 rounded-lg border border-gray-800 bg-gray-950/60 p-3">
                <div className="w-1/2 space-y-1">
                  <div className="h-2 w-10 rounded bg-gray-800" />
                  <div className="h-3 w-20 rounded bg-gray-800" />
                </div>
                <div className="w-1/2 space-y-1 text-right">
                  <div className="ml-auto h-2 w-14 rounded bg-gray-800" />
                  <div className="ml-auto h-3 w-16 rounded bg-gray-800" />
                </div>
              </div>

              {/* Footer actions */}
              <div className="mt-2 flex items-center justify-between border-t border-gray-800 pt-4">
                <div className="flex items-center gap-3">
                  <div className="h-3 w-16 rounded bg-gray-800" />
                  <div className="h-5 w-10 rounded-full bg-gray-800" />
                </div>
                <div className="flex items-center gap-2">
                  <div className="h-7 w-7 rounded-lg bg-gray-800" />
                  <div className="h-7 w-7 rounded-lg bg-gray-800" />
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PromotionSkeletons;
